import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";
import {
    AuthPaneContainer,
    Button,
    ButtonTypes,
    customToast,
    FormInput,
    Title,
    Variants
} from "toolbox-react-frontend-components";
import axios from "axios";
import {cloneDeep} from "lodash";
import Turnstile, { useTurnstile } from "react-turnstile";

const ForgotPasswordPage = (props) => {
    const navigate  = useNavigate();
    const turnstile = useTurnstile();

    const [data, setData] = useState({
        email:              '',
        cloudflare_token:   '',
    });
    const [errors, setErrors]           = useState(null);
    const [submitting, setSubmitting]   = useState(false);

    useEffect(() => {
        if (submitting) {
            submit();
        }
    }, [submitting]);

    const submit = () => {
        setErrors(null);

        axios.post(route('api.admin.password.email').toString(), data)
            .then((response) => {
                setSubmitting(false);

                customToast({
                    title:      'Forgot password processed',
                    items:      [
                        'If the email provided is valid, that email will receive a notification to reset the password.',
                    ],
                    variant:    Variants.Primary
                });
            })
            .catch((error) => {
                if (!!error && !!error.response && !!error.response.data) {
                    if (!!error.response.data.message) {
                        customToast({
                            title:      error.response.data.message,
                            variant:    Variants.Danger
                        });
                    }

                    if (!!error.response.data.errors) {
                        setErrors(error.response.data.errors);
                    }

                    turnstile.reset();

                    setSubmitting(false);
                } else {
                    console.log(error);
                    customToast({
                        title:      'An error occurred. Please refresh the page to try again.',
                        variant:    Variants.Danger
                    });
                }
            });
    }

    const updateField = (field, value) => {
        let clone = cloneDeep(data);

        switch (field) {
            default:
                clone[field] = value;
                break;
        }

        setData(clone);
    }

    return (
        <AuthPaneContainer
            fillerImage={'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e4/SSL_SL9000J_%2872ch%29_%40_The_Cutting_Room_Recording_Studios%2C_NYC.jpg/2560px-SSL_SL9000J_%2872ch%29_%40_The_Cutting_Room_Recording_Studios%2C_NYC.jpg'}
        >
            <Title
                title={'Forgot password'}
            />
            <FormInput
                type={'email'}
                label={'Email'}
                name={'email'}
                value={data.email}
                errorMessages={!!errors && !!errors.email ? errors.email : null}
                onChange={(value) => updateField('email', value)}
                disabled={submitting}
            />
            <div className={'d-flex justify-content-center align-items-center'}>
                <Turnstile
                    sitekey={CLOUDFLARE.site_key}
                    onVerify={(token) => updateField('cloudflare_token', token)}
                    theme={'light'}
                />
            </div>
            <Button
                label={submitting ? 'Requesting...' : 'Send request'}
                onClick={(event) => setSubmitting(true)}
                className={'w-100 justify-content-center mb-3 mt-5'}
                disabled={submitting}
            />
            <div className={'d-flex justify-content-center align-items-center'}>
                <Button
                    label={'Login'}
                    onClick={() => navigate(route('admin.login', undefined, false))}
                    type={ButtonTypes.Link}
                    variant={Variants.Dark}
                    disabled={submitting}
                />
            </div>
        </AuthPaneContainer>
    );
}

export default ForgotPasswordPage;
